import { useCallback, useEffect } from "react";
/**
 * Hook to focus a Form component when the native HTML input
 * is focused. Unhides and re-hides a hidden input before and
 * after submit so it can be focused.
 *
 * @param {inputRef} React.ref ref to the native HTML input
 * @param {elementToFocusRef} React.ref ref to the element to focus on error
 * @param {isSubmitting} Boolean notice from Form context that submit is impending.
 */

export default function useFocusFieldOnError(inputRef, elementToFocusRef, isSubmitting) {
  const onHiddenFieldFocus = useCallback(e => {
    elementToFocusRef.current && e.relatedTarget && typeof elementToFocusRef.current.focus === "function" && elementToFocusRef.current.focus();
  }, [elementToFocusRef]);
  useEffect(() => {
    if (isSubmitting) {
      const input = inputRef.current;

      if (input) {
        // Enable the underlying input to be focused.
        input.removeAttribute("hidden");
        input.style.display = "inline";
        setTimeout(() => {
          input.style.display = "none";
          input.setAttribute("hidden", true);
        }, 0);
      }
    }
  }, [isSubmitting, inputRef]);
  useEffect(() => {
    const input = inputRef.current;
    input && input.addEventListener("focus", onHiddenFieldFocus);
    return () => {
      input && input.removeEventListener("focus", onHiddenFieldFocus);
    };
  }, [onHiddenFieldFocus, inputRef]);
}